import React from "react";
import { CONFIG } from "../config";
import { ArrowRight } from "lucide-react";
import { ProductImage } from "./ProductImage";

export default function MechanismSection() {
  return (
    <section id="how-it-works" className="bg-white pt-8 pb-12 md:pt-12 md:pb-16 border-b border-brand-border">
      <div className="max-w-[1120px] mx-auto px-4 md:px-6">
        
        {/* Section Header */}
        <div className="text-center mb-12">
          <h2 className="font-display font-black uppercase text-brand-dark tracking-tight text-3xl sm:text-4xl lg:text-[46px] leading-none mb-4 max-w-4xl mx-auto">
            <span className="block">THEY MAKE ONE DEMAND, PAY US!</span>
            <span className="block mt-1">YOU MAKE {CONFIG.demandCount} DEMANDS, <span className="text-brand-red">PROVE IT!</span></span>
          </h2>
          <div className="max-w-[760px] mx-auto space-y-3">
            <p className="font-sans font-bold text-brand-dark text-base md:text-lg leading-relaxed">
              <span className="block">THE KILL SWITCH COMES WITH 25+ ATTACK FILES</span>
              <span className="block">BUILT FOR YOUR EXACT SITUATION AND YOUR NEXT MOVE.</span>
            </p>
          </div>
        </div>

        {/* Split Grid: Product Image & Copy (moved from ProcessSection) */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8 items-center max-w-[960px] mx-auto mb-16">
          <div className="bg-card border-4 border-brand-dark rounded-xl p-3 shadow-lg overflow-hidden">
            <ProductImage
              imageKey="boxArt"
              sizes="(min-width: 768px) 45vw, 92vw"
              loading="lazy"
              testId="process-side-image"
              className="rounded-md"
            />
          </div>

          <div>
            <p className="text-justify font-sans font-semibold text-brand-dark/90 text-sm md:text-base leading-relaxed mb-4">
              THE DEBT COLLECTOR KILL SWITCH WAS DESIGNED TO BE AN <span className="text-brand-red">OVERWHELMING ATTACK SYSTEM</span> TO <span className="text-brand-red">BEAT DEBT COLLECTORS</span> AND <span className="text-brand-red">REMOVE YOUR COLLECTIONS</span>, FAST, EASY & LEGAL!
            </p>

            <p className="text-justify font-sans font-semibold text-brand-dark/90 text-sm md:text-base leading-relaxed">
              FEDERAL LAW GIVES CONSUMERS IMPORTANT RIGHTS TO DEMAND VALIDATION. You do not need to become an attorney, spend months researching, or hope it disappears. You need a FAST and EASY, <span className="text-brand-red">CLEAR PATH FOR YOUR EXACT SITUATION</span> — what to demand, where to send it, and what comes next.
            </p>

            <p className="font-display font-black uppercase text-brand-dark tracking-tight mt-4 mb-4 text-base md:text-lg lg:whitespace-nowrap">
              KILL SWITCH IS BUILT AROUND YOUR EXACT SITUATION!
              <br />
              ACTIVATE IN 3 SIMPLE STEPS..
            </p>

            <div className="grid grid-cols-3 gap-3" data-testid="process-mini-steps">
              <div className="relative bg-white border-2 border-brand-red rounded-lg p-4 text-center overflow-hidden shadow-lg">
                <div className="absolute -top-3 -right-3 w-10 h-10 bg-brand-red rounded-full flex items-center justify-center font-display font-black text-white text-lg shadow-md">1</div>
                <span className="font-display font-black text-sm md:text-base text-brand-dark uppercase tracking-tight leading-tight">CHOOSE YOUR SITUATION</span>
              </div>
              <div className="relative bg-white border-2 border-brand-red rounded-lg p-4 text-center overflow-hidden shadow-lg">
                <div className="absolute -top-3 -right-3 w-10 h-10 bg-brand-red rounded-full flex items-center justify-center font-display font-black text-white text-lg shadow-md">2</div>
                <span className="font-display font-black text-sm md:text-base text-brand-dark uppercase tracking-tight leading-tight">FILL IN THE BLANKS</span>
              </div>
              <div className="relative bg-white border-2 border-brand-red rounded-lg p-4 text-center overflow-hidden shadow-lg">
                <div className="absolute -top-3 -right-3 w-10 h-10 bg-brand-red rounded-full flex items-center justify-center font-display font-black text-white text-lg shadow-md">3</div>
                <span className="font-display font-black text-sm md:text-base text-brand-dark uppercase tracking-tight leading-tight">DEMAND VALIDATION</span>
              </div>
            </div>
          </div>
        </div>

        {/* Section Quick CTA */}
        <div className="text-center">
          <a
            href={CONFIG.checkoutUrl}
            className="inline-flex items-center justify-center py-4 px-4 sm:px-6 bg-brand-cta hover:bg-brand-cta-hover text-white rounded-lg font-sans font-extrabold uppercase text-[11px] sm:text-sm md:text-base tracking-wide whitespace-nowrap border-b-4 border-brand-dark/30 hover:border-b-2 active:border-b-0 hover:translate-y-[2px] active:translate-y-[4px] transition-all duration-150 cursor-pointer shadow-md"
            data-testid="mechanism-signup-cta-button"
          >
            YES! I&apos;M READY TO REMOVE MY COLLECTIONS
            <ArrowRight className="w-4 h-4 ml-2" />
          </a>
          <p className="font-display font-black text-brand-dark text-sm mt-3">
            🔒 Secure checkout ⚡ Instant Private Access
          </p>
          <p className="text-center text-brand-red font-sans font-bold text-xs mt-2">
            START REMOVING YOUR COLLECTIONS TODAY!
          </p>
        </div>

      </div>
    </section>
  );
}
